import { Button, Tooltip, Stack, Typography, Link, Box } from '@mui/material';
import { useState } from 'react';
import { useAuthContext } from '../../auth/useAuthContext';
import LoginLayout from '../../layouts/login';
import AuthLoginForm from './AuthLoginForm';
import AuthRegisterForm from './AuthRegisterForm';
import AuthForgotPasswordForm from './AuthForgotPasswordForm';

export default function Login() {
  const { method } = useAuthContext();
  const [ form, setForm ] = useState('login')

  return (
    <LoginLayout>
      {form == 'login' && (
        <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
          <Typography variant="h4">Вхід</Typography>
          <AuthLoginForm />
          {/*<Link onClick={() => setForm('forgot-password')} style={{cursor: 'pointer'}}>
            Забули пароль?
          </Link>*/}
        </Stack>
      )}
      {form == 'register' && (
        <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
          <Typography variant="h4">Реєстрація</Typography>
          <AuthRegisterForm />
          <Link onClick={() => setForm('login')} style={{cursor: 'pointer'}}>
            Вже є аккаунт?
          </Link>
        </Stack>
      )}
      {form == 'forgot-password' && (
        <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
          <Typography variant="h4">Створити новий пароль?</Typography>
          <AuthForgotPasswordForm />
          <Link onClick={() => setForm('login')} style={{cursor: 'pointer'}}>
            Вже маєте пароль?
          </Link>
        </Stack>
      )}
    </LoginLayout>
  );
}
